require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = 4